import { PostMessage } from '../enums';

export const closeDocVerify = () => {
  const parentWindow = window.parent;
  parentWindow.postMessage(PostMessage.CLOSE_ID_SCAN, '*');
};
